import axios from 'axios'

export default {
  download(filter) {
    return axios.download('/api/servicecompanies/export',
      {
        countryId: filter.countryId,
        isActive: filter.isActive,
        code: filter.text,
        name: filter.text
      });
  },
    getServiceCompanies(page, isActive, countryId, text, state) {
    return axios.get('/api/servicecompanies/table',
      {
        params: {
          page: page,
          countryId: countryId,
          isActive: isActive,
          code: text,
          name: text,
          state: state
        }
      });
    },
    getParentServiceCompanies() {
        return axios.get('/api/servicecompanies/parentCompanies')
    },
  getServiceCompany(id) {
    return axios.get(`/api/servicecompanies/${id}`).then(response => {
      var result = Object.assign({}, response.data);

        result.rating = result.rating.toString();
        result.companyType = result.companyType.toString();
      result.selectedCountryState = [result.address.countryId.toString(), result.address.stateId.toString()];
      result.city = result.address.city;
      result.region = result.address.region;
      result.regional = result.address.regional;
      result.zip = result.address.zip;
      result.address = result.address.street;

      result.warrantyRegularLaborRate = result.warrantyRegular.laborRate;
      result.warrantyRegularTravelRate = result.warrantyRegular.travelRate;
      result.warrantyRegularMileageRate = result.warrantyRegular.mileageRate;
      delete result.warrantyRegular;

      result.warrantyOvertimeLaborRate = result.warrantyOvertime.laborRate;
      result.warrantyOvertimeTravelRate = result.warrantyOvertime.travelRate;
      result.warrantyOvertimeMileageRate = result.warrantyOvertime.mileageRate;
      delete result.warrantyOvertime;

      result.nonWarrantyRegularLaborRate = result.nonWarrantyRegular.laborRate;
      result.nonWarrantyRegularTravelRate = result.nonWarrantyRegular.travelRate;
      result.nonWarrantyRegularMileageRate = result.nonWarrantyRegular.mileageRate;
      delete result.nonWarrantyRegular;

      result.nonWarrantyOvertimeLaborRate = result.nonWarrantyOvertime.laborRate;
      result.nonWarrantyOvertimeTravelRate = result.nonWarrantyOvertime.travelRate;
      result.nonWarrantyOvertimeMileageRate = result.nonWarrantyOvertime.mileageRate;
      delete result.nonWarrantyOvertime;

      result.subContractorPhone = result.subContractor ? result.subContractor.phone : undefined;
      result.subContractorEmail = result.subContractor ? result.subContractor.email : undefined;
      result.subContractorContactName = result.subContractor ? result.subContractor.contactName : undefined;
      delete result.subContractor;

      return result;
    });
  },
  saveServiceCompany(id, serviceCompany) {
    var request = Object.assign({}, serviceCompany);
    request.countryId = serviceCompany.selectedCountryState[0];
    request.stateId = serviceCompany.selectedCountryState[1];
    delete request.selectedCountryState;

    if (id) {
      return axios.put(`/api/servicecompanies/${id}`, request);
    }
    return axios.post('/api/servicecompanies', request);
  },
  deleteServiceCompany(id) {
    return axios.delete(`/api/servicecompanies/${id}`);
  },
  deleteUser(name) {
    console.log(`/api/users/deletebyname/${name}`);
    return axios.delete(`/api/users/deletebyname/${name}`);
  },
  changeActivationStatus(id, status) {
    return axios.patch(`/api/servicecompanies/${id}`,
      {
        status: status
      });
  },
  resetPassword(id) {
    return axios.post(`api/servicecompanies/${id}/resetpassword`);
  },
  impersonate(id) {
      return axios.post(`/api/account/loginas/${id}`);
  },
  addSubcontractor(id, subcontractor) {
      return axios.post(`/api/servicecompanies/${id}/subcontractors`, subcontractor );
  },
  deleteSubcontractor(id, subcontractor) {
      return axios.post(`/api/servicecompanies/${id}/deletesubcontractors`, subcontractor);
  }
}



// WEBPACK FOOTER //
// ./ClientApp/app/masters/servicecompanies/api.js